import { AddressData, Position } from '90.quickConnect.Models/models';

/**
 * Indique si la valeur passée en paramètre est un champ AddressData vide
 * @param addressData
 * @returns true si le champ est vide, false sinon
 */
export const isEmptyAddressData = (addressData: AddressData): boolean =>
  Object.values(addressData).every((val: string | Position | undefined) => !!val === false);
